export default __webpack_public_path__ + "icon_overlay.49d3b9856429b8bdd2b7387b677ab297.svg";